import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
  
import { toast } from 'react-toastify';

const PhysiotherapyModalCancel = ({
    requestId,
    submitModal,
    closeModal,
    onComplete,
    modalIsOpen,
    className
}) => {

    const [value, setValue] = useState('');
    const [remarks, setRemarks] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        // Reset state when modal opens or requestId changes
        if (modalIsOpen) {
            setValue('');
            setRemarks('');
        }
    }, [requestId, modalIsOpen]);

    const handleChange = (event) => {
        const { value } = event.target;
        setValue(value);
        setRemarks('');
    };

    const handleRemarksInputChange = (event) => {
        setRemarks(event.target.value);
    };

    const handleSubmit = () => {
        if (!value) {
            return toast.error('Please select a cancellation reason');
        }

        if (value === 'Others' && !remarks.trim()) {
            return toast.error('Please provide a reason in the text field');
        }

        const cancelReason = value === 'Others' ? remarks.trim() : value;

        setIsDisabled(true);

        return submitModal(cancelReason, '')
        .then(() => {
            closeModal();
            onComplete();
        })
        .finally(() => {
            setIsDisabled(false);
        });
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            toggle={closeModal}
            className={className}
        >
            <ModalHeader className="bg-primary" toggle={closeModal}>
                Sure you want to cancel? (Request Id: {requestId})
            </ModalHeader>
            <ModalBody style={{ padding: '24px' }}>
                <div>
                    <label style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                        Reason for cancellation
                    </label>
                    <select
                        onChange={handleChange}
                        value={value}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            border: '1px solid #d9d9d9',
                            fontSize: '14px',
                            height: '40px',
                            appearance: 'auto',
                        }}
                    >
                        <option value="">Select Reason</option>
                        <option value="Physiotherapist unavailable">Physiotherapist unavailable</option>
                        <option value="Centre closed due to emergency">Centre closed due to emergency</option>
                        <option value="Slot no longer available">Slot no longer available</option>
                        <option value="Equipment/facility issue">Equipment/facility issue</option>
                        <option value="Patient not available">Patient not available</option>
                        <option value="Not covered under policy">Not covered under policy</option>
                        <option value="Visit Demo">Visit Demo</option>
                        <option value="User not available">User not available</option>
                        <option value="User requested another date / reschedule">User requested another date / reschedule</option>
                        <option value="Slot not suitable / not comfortable with booked slot">Slot not suitable / not comfortable with booked slot</option>
                        <option value="Location not serviceable">Location not serviceable</option>
                        <option value="User changed mind / will book later">User changed mind / will book later</option>
                        <option value="Delayed confirmation from center">Delayed confirmation from center</option>
                        <option value="Center issue / service denial">Center issue / service denial</option>
                        <option value="Looking for home visit only">Looking for home visit only</option>
                        <option value="Looking for center visit only">Looking for center visit only</option>
                        <option value="Others">Others</option>
                    </select>
                    {value === 'Others' && (
                        <div style={{ marginTop: '16px' }}>
                            <label style={{ fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                                Please specify <span style={{ color: 'red' }}>*</span>
                            </label>
                            <textarea
                                onChange={handleRemarksInputChange}
                                value={remarks}
                                maxLength={500}
                                placeholder="Enter reason here..."
                                style={{
                                    width: '100%',
                                    minHeight: '90px',
                                    resize: 'vertical',
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d9d9d9',
                                    fontSize: '14px',
                                }}
                            />
                            <small style={{ color: '#999', float: 'right' }}>{remarks.length}/500</small>
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" outline onClick={closeModal}>
                    Close
                </Button>
                <Button
                    color="info"
                    onClick={handleSubmit}
                    disabled={isDisabled || (value === 'Others' && !remarks.trim())}
                >
                    Confirm Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PhysiotherapyModalCancel;
